import {Component, ViewContainerRef} from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { StateService, Transition, TransitionService } from "@uirouter/angular";
import {ViewService} from './services/view.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { SessionService } from '@edl-development/edl-common';
import { environment } from './../environments/environment';


declare let gtag: Function;
@Component({
    selector: 'edl-paetep',
    templateUrl: 'edl-paetep.component.html',
    encapsulation: ViewEncapsulation.None
})

export class EdlPaetepComponent {
    constructor(
        private viewService: ViewService,
        private vcr: ViewContainerRef,
        private transitionService: TransitionService,
        private loadingBarService: LoadingBarService,
        private stateService: StateService,
        public sessionService: SessionService
    ) {
        viewService.viewContainerRef = vcr;

        this.sessionService.PersistToken.push('user-default-building', 'user_default_schoolYear', 'user-default-role-search', 'user-default-action-required', 'user-default-search-string', 'user-default-supervisor-only', 'user-default-search-string');

        this.sessionService.InitializeAuth(environment.FIREBASECONFIG, environment.FIREBASE_TENANT);

        transitionService.onSuccess({ }, (transition) => {
            try {
                gtag('set', 'page_path', window.location.pathname);
                gtag('event', 'page_view');
            } catch (e){ }
        });
        transitionService.onSuccess({ }, (transition) => {
            if (transition.to()?.name === 'public.logout') {
                this.sessionService.destroy();

                // Redirect to the login page
                this.stateService.go('public.login');
            } else if(this.sessionService.isAuthenticated() ) {
                this.sessionService.Initialized(true);
            }

            if (transition.to().name !== transition.from().name) {
                window.scrollTo(0, 0);
            }

            this.loadingBarService.stop();

            this.toggleScrollBehavior_Smooth();
        });

        transitionService.onError({}, (transition: Transition) => {
            const to = transition.to();
            const error = transition.error();
            const params = transition.params();

            this.loadingBarService.useRef().stop();

            // If an error occurs due to the user not having permission to access the page
            // then take them to the unauthorized page
            if(error?.detail?.status === 401 || error?.detail?.status === 403) {
                transition.router.stateService.go('public.unauthorized');
            } else if ((error?.detail?.status ?? 0) >= 400) {
                transition.router.stateService.go('public.generic-error');
            }

            this.toggleScrollBehavior_Smooth();
        });

        transitionService.onBefore({}, (transition) => {
            let from = transition.from();
            let to = transition.to();
            const isPublic = to?.data?.isPublic;

            if (!isPublic && this.sessionService.isAuthenticated() && sessionService.userAgreement && to.name !== 'authenticated.user-agreement') {
                const loggedInPortal = sessionService.PortalSettings?.URLSubdirectory;
                return transition.router.stateService.target('authenticated.user-agreement', { loggedInPortal });
            }

            if (from.name !== to.name) {
                this.loadingBarService.set(0);
                this.loadingBarService.start();
            }

            this.toggleScrollBehavior_Auto();

            return undefined;
        });

        /*
        transitionService.onFinish({}, (transition) => {
            const to = transition.to();
            if (to.name === 'public.logout') {
                // Destroy the session
                this.sessionService.destroy();

                // Redirect to the login page
                return transition.router.stateService.target('public.login');
            }

            return undefined;
        });
        */
    }

    toggleScrollBehavior_Auto() {
        document.documentElement.style.scrollBehavior = 'auto';
    }

    toggleScrollBehavior_Smooth() {
        document.documentElement.style.scrollBehavior = 'smooth';
    }
}
